import { Apps, BugReport, Settings, Wifi } from '@mui/icons-material';
import { Box, SvgIconProps } from '@mui/material';
import React from 'react';
import { CommandCategory } from '../../types/commands';

interface CommandCategoryIconProps {
  category: CommandCategory;
  size?: 'small' | 'medium' | 'large';
  color?: string;
}

const categoryConfig: Record<
  CommandCategory,
  {
    icon: React.ComponentType<SvgIconProps>;
    color: string;
    label: string;
  }
> = {
  system: {
    icon: Settings,
    color: '#081f2c',
    label: 'System',
  },
  application: {
    icon: Apps,
    color: '#f1be48',
    label: 'Application',
  },
  network: {
    icon: Wifi,
    color: '#2196f3',
    label: 'Network',
  },
  diagnostics: {
    icon: BugReport,
    color: '#4caf50',
    label: 'Diagnostics',
  },
};

const sizeMap = {
  small: 'small' as const,
  medium: 'medium' as const,
  large: 'large' as const,
};

export const CommandCategoryIcon: React.FC<CommandCategoryIconProps> = ({ category, size = 'medium', color }) => {
  const config = categoryConfig[category];
  // Fallback to system if category is not found
  if (!config) {
    const fallbackConfig = categoryConfig.system;
    const IconComponent = fallbackConfig.icon;
    return (
      <Box
        sx={{
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <IconComponent fontSize={sizeMap[size]} sx={{ color: color || fallbackConfig.color }} />
      </Box>
    );
  }

  const IconComponent = config.icon;

  return (
    <Box
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <IconComponent fontSize={sizeMap[size]} sx={{ color: color || config.color }} />
    </Box>
  );
};
